import React, { useState } from "react";
import { Steps, Form, Input, Button, message, Col, Row, Tooltip, InputNumber } from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import styles2 from '../OtherPages/OtherPages.module.css';
import styles from './Form.module.css';
import Navbar from "../../Components/Navbar/Navbar";
import staff from '../../assets/staff.png';
import patient from '../../assets/patient.png';

import { motion } from 'framer-motion';
import { BsQuestionCircle } from "react-icons/bs";
import { getErrorMessage } from "../../util/GetError";
import axios from "../../util/axios";
import ReactQuill from "react-quill";
import parse from 'html-react-parser';
import { FiPlus } from "react-icons/fi";

import resource from '../../assets/resources.png';
import { getTranslation } from "../../util/utilFunc";

const { Step } = Steps;

const modules = {
  // syntax: { highlight: (text) => hljs.highlightAuto(text).value },
  toolbar: {
    container: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
      ["link"],
      ["clean"],
    ],
  },
};

const EvaluationForm = () => {
  const [isPatient, setIsPatient] = useState(false);
  const [currentStep, setCurrentStep] = useState(0); // Track the current step
  const { userInfo, language } = useSelector(state => state.auth);
  const [projectOverview, setProjectOverview] = useState("");
  const [projectWhere, setProjectWhere] = useState("");
  const [projectWhen, setProjectWhen] = useState("");
  const [consequences, setConsenquences] = useState("");
  const [frequency, setFrequency] = useState("");
  const [projectWho, setProjectWho] = useState("");
  const [problemStatement, setProblemStatement] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [loading, setLoading] = useState(false);
  const [isEditProblemStatement, setIsEditProblemStatement] = useState(false);
  const [proposedSolution, setProposedSolution] = useState("");
  const [patientId, setPatientId] = useState("");
  const navigate = useNavigate();
  const [usersAffected, setUsersAffected] = useState("");
  const [themeAssesment, setThemeAssesment] = useState("");


  const [form] = Form.useForm(); // Antd form instance



  const handleSubmitForm3 = async () => {
    try {
      setLoading(true);

      let data = {
        themeAssesment,
        session_id: sessionId,
        user_id: userInfo?.user_id,
        usersAffected,

      }
      const response = await axios.post('/form_page_data_3', data);
      //console.log(response.data);
      if (response.status === 200) {
        setCurrentStep(currentStep + 1);
      }
    } catch (err) {
      console.log(err);
      message.error(getErrorMessage(err));
      setLoading(true);
    }
  }


  const handleTextAreaResize = (e) => {
    e.target.style.height = 'auto';
    e.target.style.height = `${e.target.scrollHeight}px`;
  }


  const navigateToLogin = () => {
    if (userInfo) {
      navigate('/dashboard/generate-idea');
      return;
    }
    navigate("/login");
  };

  const handleSubmitForm1 = async () => {
    setLoading(true);

    try {
      let data = {
        patient_id: patientId,
        What: projectOverview,
        Where: projectWhere,
        When: projectWhen,
        Who: projectWho,
        Frequency: frequency,
        Consequences: consequences,
        proposedSolution: proposedSolution

      };

      if (problemStatement) {
        const response = await axios.post('/form_page_data_1', data);
        if (response.status === 200) {
          setSessionId(response.data.session_id);
          setCurrentStep(currentStep + 1);
          setLoading(false);
          return;
        }

      }

      const response = await axios.post('/problemstatement', data);
      //console.log(response.data);
      if (response.status === 200) {
        setProblemStatement(response.data?.response);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
      message.error(getErrorMessage(err));
    }

  }

  const next = async () => {
    try {
      await form.validateFields(); // Validate form fields before moving to the next step
      form.submit(); // Submit the current form step
    } catch (error) {
      message.error(getTranslation("Please fill in all required fields before proceeding.", language));
    }
  };

  const onFinish = async (values) => {
    let data = {
      "first_name": values?.firstName,
      "last_name": values?.lastName,
      "email": values?.email,
      "contact": values?.contact,
      "site_visited": values?.siteLocation,
      "department": values?.department
    }

    try {
      const response = await axios.post('/create-patient/', data);
      if (response.data) {
        setCurrentStep(currentStep + 1); // Move to the next step
        setPatientId(response.data?.patient_id);
      }
    } catch (err) {
      console.log(err);
      message.error(getErrorMessage(err));
    }
  };




  // Form layout for each step
  const steps = [
    {
      title: getTranslation("Personal Information", language),
      content: (
        <>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                label={getTranslation("First Name", language)}
                name="firstName"
                rules={[
                  { required: true, message: getTranslation("Please input your first name!", language) },
                ]}
              >
                <Input placeholder={getTranslation("Enter your first name", language)} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label={getTranslation("Last Name", language)}
                name="lastName"
                rules={[
                  { required: true, message: getTranslation("Please input your last name!", language) },
                ]}
              >
                <Input placeholder={getTranslation("Enter your last name", language)} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label={getTranslation("Email", language)}
                name="email"
                rules={[
                  { required: true, message: getTranslation("Please input your email!", language) },
                  { type: 'email', message: getTranslation("Please enter a valid email address!", language) },
                ]}
              >
                <Input placeholder={getTranslation("Enter your email", language)} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                label={getTranslation("Contact", language)}
                name="contact"
                rules={[
                  { required: true, message: getTranslation("Please input your contact number!", language) },
                ]}
              >
                <Input placeholder={getTranslation("e.g. +19992999292", language)} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label={getTranslation("Site Location Visited", language)}
                name="siteLocation"
                rules={[
                  { required: true, message: getTranslation("Please input the site location visited!", language) },
                ]}
              >
                <Input placeholder={getTranslation("Enter site location visited", language)} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label={getTranslation("Department or Ward", language)}
                name="department"
                rules={[
                  { required: true, message: getTranslation("Please input the department or ward!", language) },
                ]}
              >
                <Input placeholder={getTranslation("Enter department or ward", language)} />
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },
    {
      title: getTranslation("Problem Statement", language),
      content: (
        <div className={styles.form__body}>
          {problemStatement ? (
            <div>
              {isEditProblemStatement ? (
                <>
                  <ReactQuill
                    value={problemStatement}
                    modules={modules}
                    onChange={setProblemStatement}
                  />
                  <div className={styles.problem__btn__wrapper}>
                    <Button
                      size="large"
                      onClick={() => setIsEditProblemStatement(false)}
                    >
                      {getTranslation("Cancel", language)}
                    </Button>
                    <button
                      className="primaryBtn"
                      onClick={() => setIsEditProblemStatement(false)}
                    >
                      {getTranslation("Save", language)}
                    </button>
                  </div>
                </>
              ) : (
                <div className={styles.form__body__problemStatement}>
                  {parse(problemStatement)}
                  <button
                    className="primaryBtn"
                    onClick={() => setIsEditProblemStatement(true)}
                  >
                    {getTranslation("Edit", language)}
                  </button>
                </div>
              )}
            </div>
          ) : (
            <>
              <div className={styles.input__wrapper}>
                <h3>{getTranslation("Explain your idea", language)}</h3>
                <label>
                  {getTranslation(
                    "Can you describe your idea, focusing on what it is and the specific impact you envision it having?",
                    language
                  )}
                  <sup style={{ color: "red" }}>*</sup>
                  <Tooltip title={getTranslation("The Problem statement includes what is being affected", language)}>
                    <BsQuestionCircle />
                  </Tooltip>
                </label>
                <Input.TextArea
                  placeholder={getTranslation(
                    "In a few sentences, Please Describe what the project is about and how it will help improve MTW as an organisation. Be specific, focus on the What not the Why.",
                    language
                  )}
                  size="small"
                  type="text"
                  value={projectOverview}
                  onChange={(e) => setProjectOverview(e.target.value)}
                  onInput={handleTextAreaResize}
                />
              </div>
            </>
          )}
        </div>
      ),
    },
  ];


  //console.log(currentStep);

  return (
    <div className={styles2.bg__primary}>
      <Navbar />
      <div className={styles.box}>
        {isPatient ? (
          <>
            <h3>{getTranslation("Generate Your Idea", language)}</h3>
            <Steps current={currentStep}>
              {steps.map((item) => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>

            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              className={styles.ideaForm}
            >
              <div className={styles.step__content}>{steps[currentStep].content}</div>

              <div className={styles.step__buttons}>
                {currentStep === 0 && (
                  <Button type="primary" onClick={next}>
                    {getTranslation("Submit & Next", language)}
                  </Button>
                )}

              </div>
            </Form>
          </>
        ) : (
          <>
            <h2>{getTranslation("Please Select Your Role", language)}</h2>
            <div className={styles.image__wrapper}>
              <div onClick={() => setIsPatient(true)} className={styles.image__card}>
                <img src={patient} alt="Patient" />
                <h3>{getTranslation("Patient", language)}</h3>
              </div>
              <div onClick={navigateToLogin} className={styles.image__card}>
                <img src={staff} alt="Staff" />
                <h3>{getTranslation("Staff", language)}</h3>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EvaluationForm;
